import React from 'react';
import './Skeleton.scss';

export interface ISkeletonProps {
  variant?: 'text' | 'cicrular' | 'rectangular';
  classes?: string;
}

const Skeleton = ({ variant, classes }: ISkeletonProps): JSX.Element => {
  return <span className={`ahm-skeleton ${variant || ''} ${classes || ''}`} />;
};

export default Skeleton;
